<div class='container mt-3'>
  <p-confirmpopup></p-confirmpopup>
  <form [formGroup]="attachmentForm" (ngSubmit)="save()">
    <h5>Datei Hochladen</h5>
    <div class="p-fluid grid mt-3">

      <div class="field col-12">
        <p-floatlabel>
          <input pInputText id="name" formControlName="name" class='w-100' />
          <label for="name">Beschreibung der Datei</label>
        </p-floatlabel>

        @if (attachmentForm.get('name')?.errors?.['required'] && attachmentForm.get('name')?.dirty) {
          <span class='p-error'>
            Beschreibung ist erforderlich
          </span>
        }
      </div>
    </div>

    <p-fileUpload #fileUpload
                  mode="basic"
                  chooseLabel="Datei Auswählen"
                  name="file"
                  [accept]="acceptedFileTypes"
                  maxFileSize="5000000"
                  invalidFileTypeMessageSummary="{0}: Ungültiger Dateityp"
                  invalidFileTypeMessageDetail="Nur PDF-Dateien sind erlaubt."
                  invalidFileSizeMessageSummary="{0}: Ungültige Dateigröße"
                  invalidFileSizeMessageDetail="Maximale Dateigröße: {0}. Bitte Datei komprimieren"
                  (onSelect)="onFileSelect($event)"
                  (click)="fileUpload.clear()"></p-fileUpload>

    <div class="w-100 d-flex justify-content-end mb-3">
      <p-button type="submit" label="DATEI HOCHLADEN" icon="pi pi-save" [rounded]="true"></p-button>
    </div>
  </form>

  @if (attachmentsService.attachments.length > 0) {
    <p-table [value]="attachmentsService.attachments" [paginator]="attachmentsService.attachments.length > 10" [rows]="10"
    [showCurrentPageReport]="true" currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Dateien"
    [loading]="loading">

    <ng-template pTemplate="header">
      <tr>
        <th>Beschreibung</th>
        <th>Dateiname</th>
        <th>Erstellt am</th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-attachment>
      <tr>
        <td>{{ attachment.name }}</td>
        <td>{{ attachment.file?.name }}</td>
        <td>{{ attachment.createdAt | date : 'dd.MM.yyyy \'um\' HH:mm \'Uhr\'' }}</td>
        <td>
          <p-button icon="pi pi-download" severity="success" [outlined]="true" [rounded]="true"
          (click)="download(attachment)"></p-button>
          @if (canDeleteFiles) {
            <p-button icon="pi pi-trash" class="ml-2" severity="danger" [rounded]="true" [outlined]="true"
            (click)="delete(attachment.id, $event)"></p-button>
          }
        </td>
      </tr>
    </ng-template>

  </p-table>
  }
</div>
